import globalConfig from '@/lib/http/global-config'
import axios from 'axios'
import tsignHttp from '@tsign/tsign-http'
// @ts-ignore
import tsignData from '@/lib/tsignData.ts'
import { goLoginPage } from '@/lib/utils'
import { getTokenHeader } from '@/plugins/token'
import Vue from 'vue'
// @ts-ignore
import { backToLogin } from '@esign/esign-plugin/lib/esign-jssdk'

const LOGIN_EXPIRED = 401

declare const process: Process
interface Process {
  [t: string]: any
}
console.log('process.env.environment', process.env)
declare const window: any

// 全局请求配置
axios.defaults.timeout = 100000
axios.defaults.headers['x-requested-with'] = 'XMLHttpRequest'
axios.defaults.withCredentials = true
console.log('process.env.VUE_APP_MODE', process.env.VUE_APP_MODE, process.env)
if (process.env.VUE_APP_MODE === 'dev' && process.env.groupId) {
  axios.defaults.headers['X-Tsign-Service-Group'] = process.env.groupId
}

// 配置默认请求头
Object.assign(axios.defaults.headers, {
  'X-Tsign-Open-App-Id': '',
  'X-Tsign-Open-Tenant-Id': '',
  'X-Tsign-Client-Id': 'WEB',
  'X-Tsign-Client-AppName': 'web-treaty-front_2.0',
})

// 配置官网请求实例
const CMSAxios = axios.create({
  baseURL: globalConfig.baseUrl,
  withCredentials: true,
})

CMSAxios.interceptors.response.use(
  (response: any) => {
    // 服务器返回消息体
    return response.data
  },
  (error: any) => {
    // 服务端打印api接口请求错误日志
    if (process.server) {
      try {
        const {
          config: { url },
          message,
        } = error
        console.log(`请求url：${url}，错误消息：${message}`)
      } catch (error) {
        // console.log(error)
      }
    }

    // 服务端，客户端统一reject错误对象，因此页面组件asyncData，fetch函数请求api接口一定要做catch处理
    // 组件的beforeCreated, created钩子(会在node端运行)函数请求api接口也一定要做catch处理
    return Promise.reject(error)
  }
)

// 神策埋点配置
const presetProps = tsignData.getPresetProperties()

const httpHeader = Object.assign(
  {
    // eslint-disable-next-line camelcase
    _latest_tsign_source_type: presetProps['_latest_tsign_source_type'] || '',
    // eslint-disable-next-line camelcase
    _latest_tsign_source_detail: presetProps['_latest_tsign_source_detail'] || '',

    ...getTokenHeader(), // 带token的登录方式
  },
  axios.defaults.headers
)

const options = {
  baseURL: process.env.VUE_APP_API_URL,
  headers: httpHeader,
  transformRequest(req: any) {
    // 区分H5，PC端
    // req.headers = {
    //   ...(req.headers || {}),
    //   'X-Tsign-Client-Id': isMobile() ? 'H5' : 'PC',
    // }

    const timer = Date.now()
    req.url = req.url.includes('?') ? `${req.url}&t=${timer}` : `${req.url}?t=${timer}`

    return req
  },
  transformAjax() {
    return 'axios'
  },

  // transformRequest: req => req,
  transformResponse(res: any) {
    // 过滤层
    return res.data
  },
  success: (res: any) => res,
  fail(err: any) {
    // 全局错误处理
    if (err.code && err.code === LOGIN_EXPIRED) {
      return goLoginPage()
    }

    return err
  },
  complete(res: any) {
    // 天眼
    if (res && res.data && res.data.code !== 0) {
      try {
        window.$skyeye && window.$skyeye.ajaxError(res)
      } catch (e) {
        console.error('天眼配置错误', e)
      }
    }

    return res.data
  },
}

const Http = tsignHttp.create(options)

const EHttp = tsignHttp.create(
  Object.assign({}, options, {
    fail(err: any) {
      // 全局错误处理
      if (err.code && err.code === LOGIN_EXPIRED) {
        return backToLogin(err.data.loginUrl)
      }

      // 如果是普通的错误处理，则toast提示
      Vue.prototype.$toast(err.message || '未知错误')

      return err
    },
  })
)

export const $CMSAxios = CMSAxios
export const $Http = Http
export const $EHttp = EHttp
